<template>
  <ankh-list>
    <template #btn-group>
      <el-button icon="el-icon-plus" @click="addDialog = true">{{ $t('新增') }}</el-button>
      <el-button icon="el-icon-delete" @click.native="handleBatchDelete">{{ $t('批量删除') }}</el-button>
      <el-button icon="el-icon-folder-opened" @click.native="handleExport">{{ $t('导出') }}</el-button>
    </template>

    <template #search-form>
      <el-form-item :label="$t('用户名称')">
        <el-input :placeholder="$t('用户名称')" v-model="searchForm.nickname" clearable/>
      </el-form-item>

      <el-form-item :label="$t('生成时间')">
        <date-time-range-picker
            :end-time.sync="searchForm.endCreateTime"
            :start-time.sync="searchForm.startCreateTime"/>
      </el-form-item>

      <el-form-item :label="$t('虚拟手机号')">
        <el-input :placeholder="$t('虚拟手机号')" v-model="searchForm.phone" clearable/>
      </el-form-item>

<!--      <el-form-item :label="$t('虚拟邮箱')">-->
<!--        <el-input :placeholder="$t('虚拟邮箱')" v-model="searchForm.email" clearable/>-->
<!--      </el-form-item>-->

      <el-form-item>
        <el-button type="primary" @click="$refs.list.handleSearch()">{{ $t('搜索') }}</el-button>
        <el-button @click="$refs.list.reset()">{{ $t('重置') }}</el-button>
      </el-form-item>
    </template>

    <template #table="{height}">
      <table-list
          :height="height"
          ref="list"
          row-key="id"
          @query="handleSearch"
          :search-params="searchForm"
          :request-params="{type: 'vir'}"
          :data="tableData"
          :indent="16"
          @selection-change="selection = $event">

        <el-table-column type="selection" width="50"/>

        <el-table-column prop="num" :label="$t('虚拟用户编号')" fixed="left"/>

        <el-table-column prop="nickname" :label="$t('用户名称')"/>
        <el-table-column prop="phone" :label="$t('虚拟手机号')"/>
<!--        <el-table-column prop="email" :label="$t('虚拟邮箱')"/>-->
        <el-table-column prop="password" :label="$t('用户密码')">
          <span>123456</span>
        </el-table-column>
        <el-table-column prop="createTimeS" :label="$t('生成时间')">
          <template v-slot="{row}">
            {{ row.createTime | formatDate }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('状态')">
          <template v-slot="{row}">
            <dict-text dict-flag="AN_USER_STATUS" :status="row.userBandStatus"/>
          </template>
        </el-table-column>
        <el-table-column fixed="right" :label="$t('操作')" min-width="90">
          <template v-slot="{row}">
            <div class="fb-link-flex">
              <el-link
                  :type="row.userBandStatus === 'yes' ? 'primary' : 'danger'"
                  :underline="false"
                  @click="handleChangeStatus(row)">{{ row.userBandStatus === "yes" ? $t('启用') : $t('禁用') }}
              </el-link>
              <el-link type="danger" :underline="false" @click="handleDelete(row)">{{ $t('删除') }}</el-link>
            </div>
          </template>
        </el-table-column>
      </table-list>
    </template>

    <template #other>
      <el-dialog :visible.sync="addDialog" :close-on-click-modal="false" @close="handleCloseAddDialog">
        <template #title>
          <h4>{{ $t('新增虚拟账号') }}</h4>
        </template>
        <el-form label-width="100px" ref="form" :rules="rules" :model="addFormData">
          <el-form-item :label="`${$t('生成数量')}：`" prop="count">
            <el-input :placeholder="$t('请输入生成数量')" v-model.number="addFormData.count"/>
          </el-form-item>
        </el-form>

        <template #footer>
          <el-button type="primary" @click="handleAddVirUser">{{ $t('确定') }}</el-button>
          <el-button @click="addDialog = false">{{ $t('取消') }}</el-button>
        </template>

      </el-dialog>
    </template>
  </ankh-list>
</template>

<script>
import TableList from "@/components/table-list/TableList";
import {request, requestByTip} from "@/config/request";
import DictText from "@/components/dict/DictText";
import DateTimeRangePicker from "@/components/time/DateTimeRangePicker";
import {resetEmpty} from "@/utils/common";
import AnkhList from "@/components/list/AnkhList.vue";
import {exportExcel} from "@/utils/export";

export default {
  name: "VirtualUserList",
  components: {AnkhList, DateTimeRangePicker, DictText, TableList},
  data() {
    return {
      searchForm: {},
      tableData: [],
      selection: [],
      addDialog: false,
      addFormData: {
        count: null,
      },
      moment: this.$moment,
      rules: {
        count: [
          {required: true, message: this.$t('请输入生成数量'), trigger: 'blur'},
          {type: 'number', message: this.$t('生成数量必须为数字值'), trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    //新增虚拟用户
    handleAddVirUser() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return;
        try {
          await request(this.$api.anUser.addVir, this.addFormData);
          this.addDialog = false;
          this.$message.success(this.$t('新增成功'));
          this.$refs.list.handleRequest();
        } catch (e) {
          console.log(e);
        }
      })
    },

    // 关闭新增弹窗
    handleCloseAddDialog() {
      resetEmpty(this.addFormData);
      this.$refs.form.resetFields();
    },


    async handleChangeStatus(row) {
      try {
        let params = {
          code: row.code,
          userBandStatus: row.userBandStatus === "yes" ? "no" : "yes"
        }
        await request(this.$api.anUser.updateStatus, params);
        this.$message.success(this.$t('操作成功'))
        this.$refs.list.handleRequest();
      } catch (e) {
        console.log(e);
      }
    },

    async handleDelete(row) {
      try {
        await requestByTip(this.$api.anUser.delete, {code: row.code});
        this.$message.success(this.$t('操作成功'))
        this.$refs.list.handleRequest();
      } catch (e) {
        console.error(e);
      }
    },

    async handleBatchDelete() {
      if (!this.selection.length) {
        this.$message({
          type: 'warning',
          message: this.$t('未选择记录')
        });
        return;
      }
      try {
        let codes = this.selection.map(item => item.code);
        await requestByTip(
            this.$api.anUser.batchDelete,
            codes,
            {isJson: true},
            {message: this.$t('您现在正在进行批量删除操作, 是否继续?')}
        );
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest();

      } catch (e) {
        console.error(e);
      }
    },

    async handleSearch(params) {
      try {
        let res = await request(this.$api.anUser.list, params);
        for (let key in res) {
          if (res[key] instanceof Array) {
            this.tableData = res[key];
          }
        }
        if (this.$refs?.list) {
          this.$refs.list.setTotal(res.pager?.itemCount);
        }
      } catch (e) {
        console.error(e);
      }
    },
    handleExport() {
      // console.log(this.selection);
      const codes=this.selection.map(item=>item.code);
      exportExcel(codes,this.$api.anUser.exportVirUser);
    }
  },
}
</script>

<style scoped>

.cover-image {
  width: 100px;
  height: 100px;
  object-fit: cover;
}

/deep/ .el-dialog {
  width: 550px;
  border-radius: 10px;
}


</style>
